<template>
  <div class="app">
      <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data(){
    return{
    }
  }
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
</style>
